import React, { useState, useEffect } from 'react';
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import { Link, useNavigate } from 'react-router-dom';
import { useToast } from '../contexts/ToastContext.jsx';
import { useTheme } from '../contexts/ThemeContext.jsx';
import UnifiedParrotCreation from '../components/UnifiedParrotCreation.jsx';
import ParrotFormEnhanced from '../components/ParrotFormEnhanced.jsx';

export default function ParrotNew() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { theme } = useTheme();
  const [useEnhancedCreation, setUseEnhancedCreation] = useState(true);

  // Redirect to wizard by default
  useEffect(() => {
    navigate('/parrots/new/step1');
  }, [navigate]);

  const handleParrotComplete = (parrotData) => {
    showToast(`Parrot "${parrotData.name || 'Unnamed'}" created successfully!`, 'success');
    navigate('/parrots');
  };

  const handleCancel = () => {
    navigate('/parrots');
  };

  const handleError = (error) => {
    showToast(error, 'error');
  };

  return (
    <>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
      <SignedIn>
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-4">
              <Link 
                to="/parrots" 
                className="text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300 flex items-center gap-2"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Back to Parrots
              </Link>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Create New Parrot</h1>
            </div>
            
            {/* Creation Mode Toggle */}
            <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-600 dark:text-gray-400 dark:text-gray-300 dark:text-gray-600">Mode:</span>
              <button
                onClick={() => setUseEnhancedCreation(!useEnhancedCreation)}
                className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
                  useEnhancedCreation 
                    ? 'bg-teal-600 text-white' 
                    : 'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-500'
                }`}
              >
                {useEnhancedCreation ? 'Enhanced' : 'Legacy'}
              </button>
            </div>
          </div>
          
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
            {useEnhancedCreation ? (
              <UnifiedParrotCreation
                onComplete={handleParrotComplete}
                onCancel={handleCancel}
                onError={handleError}
                mode="standalone"
                theme={theme}
                enableProgressSaving={true}
                showNameInput={true}
                showVoiceSelection={true}
                showQuickActions={true}
              />
            ) : (
              <ParrotFormEnhanced />
            )}
          </div>
        </div>
      </SignedIn>
    </>
  );
}
